'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';

export const componentName = 'HeaderLoginIcon';

export enum OFFICIAL_HEADER_LOGIN_ICON_KEY {
    LOGIN_ICON = 'official-site-header-login-icon',
}

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.HEADER_LOGIN_ICON,
    name: componentName,
    enable: true,
    next: null,
    deletable: false,
};

export const features = [FEATURE_FLAG_KEYS.HEADER_ICON_STYLE, FEATURE_FLAG_KEYS.COLOR];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.HEADER_ICON_STYLE]: 'style_1',
} as const;

export function createHeaderLoginIcon(presetStyle?: LayoutNodeStyleMap[string]) {
    const id = getElementUlId();

    const layout = {
        ...config,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
    };
}
